module.exports = __webpack_public_path__ + "static/media/Mesa-Doble-.a333a962.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-Productos/Imagen/Mesa-Doble-.png
// module id = 127
// module chunks = 0